import { render, staticRenderFns } from "./weekly-wbs-groups.vue?vue&type=template&id=1cc3197a&scoped=true"
import script from "./weekly-wbs-groups.vue?vue&type=script&lang=js"
export * from "./weekly-wbs-groups.vue?vue&type=script&lang=js"
import style0 from "./weekly-wbs-groups.vue?vue&type=style&index=0&id=1cc3197a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc3197a",
  null
  
)

export default component.exports